import { ERequestStatus, ERequestStatusColor } from "../../../common-interfaces/interfaces";


export const statusColorMap: Record<ERequestStatus, ERequestStatusColor> = {
  [ERequestStatus.PENDING]: ERequestStatusColor.PENDING,
  [ERequestStatus.REFUSED]: ERequestStatusColor.REFUSED,
  [ERequestStatus.ACCEPTED]: ERequestStatusColor.ACCEPTED,
  [ERequestStatus.COMPLETED]: ERequestStatusColor.COMPLETED
};
